




































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Placename } from '../models/Placename';
import PlacenamesService from '../services/PlacenamesService';
import Graphic from '@arcgis/core/Graphic';
import Point from '@arcgis/core/geometry/Point';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';

@Component
export default class AddData extends Vue {

    get editFeature(): Placename | null {
        return this.$store.state.editFeature;
    }

    get addDataShow(): boolean {
        return this.$store.state.leftDrawerContent.edit;
    }

    get mapView(): __esri.MapView {
        return this.$store.state.mapView;
    }

    get sources() {
        return this.$store.state.sources;
    }

    get communitiesLayerUrl() {
        return this.$store.state.communitiesLayer.url;
    }

    get user() {
        return this.$store.state.user;
    }

    get unapprovedCount() {
        return this.$store.state.unapproved.count;
    }

    public maxFileSize: number = 1024000;

    public showInstruction = false;
    public isSaving = false;
    public isCountyLoading = false;

    public objectId?: number |  null = null;
    public smithName: string = '';
    public smithName2?: string = '';
    public englishName: string = '';

    public name: string = '';
    public sourceId: number = 0;
    public meaning = '';
    public source = '';
    public sourceDetail = '';

    public translation?: string = '';
    public comment?: string = '';
    public addedSources: any = [];

    public markerGraphic: __esri.Graphic | null = null;
    public eventHandler: any = null;
    public x: number = 0;
    public y: number = 0;
    public county?: string = 'Undefined';
    public enteredBy?: string = '';
    public approved?: number = 0;

    public audioFile: File | null = null;
    public video?: string = '';
    public videos?: string[] = [];

    public newPointSymbol = {
        type: 'simple-marker',  // autocasts as new SimpleMarkerSymbol()
        style: 'x',
        color: 'blue',
        size: 10,
        outline: {  // autocasts as new SimpleLineSymbol()
            color: 'blue',
            width: 4,
        },
    };

    public sourceToText(source: string) {
        console.log('source2Text');
        console.log(this.sources[source]);
        return this.sources[source];
    }

    @Watch('addDataShow', { immediate: true, deep: true })
    public addDataShowChanged(value: boolean, oldValue: boolean) {
        console.log('addDataShow changed');
        if (value === true) {
            this.isSaving = false;
            this.isCountyLoading = false;
            if (this.editFeature) {
                this.objectId = this.editFeature.objectId;

                // inherit enteredby / approved these can't be changed
                this.enteredBy = this.editFeature.enteredBy;
                this.approved = this.editFeature.approved;

                this.x = this.editFeature.x;
                this.y = this.editFeature.y;
                this.showMarker();

                this.county = this.editFeature.county;
                this.smithName = this.editFeature.smithName;
                this.smithName2 = this.editFeature.smithName2;
                this.englishName = this.editFeature.englishName;
                this.translation = this.editFeature.translation;
                this.video = this.editFeature.video;
                this.videos = this.editFeature.video ? this.editFeature.video.split('|') : [];
                this.comment = this.editFeature.comment;
                if (this.editFeature.audioLink) {
                    // don't care about data when editing, just the name
                   this.audioFile = new File([], this.editFeature.audioLink);
                }
                if (this.editFeature.name1) {
                    this.addedSources.push({
                        sourceId: this.sourceId,
                        name: this.editFeature.name1,
                        meaning: this.editFeature.meaning1,
                        source: this.editFeature.source1 ? this.sources[this.editFeature.source1] : '',
                        sourceDetail: this.editFeature.sourceDetail1,
                    });
                    this.sourceId++;
                }
                if (this.editFeature.name2) {
                    this.addedSources.push({
                        sourceId: this.sourceId,
                        name: this.editFeature.name2,
                        meaning: this.editFeature.meaning2,
                        source: this.editFeature.source2 ? this.sources[this.editFeature.source2] : '',
                        sourceDetail: this.editFeature.sourceDetail2,
                    });
                    this.sourceId++;
                }
                if (this.editFeature.name3) {
                    this.addedSources.push({
                        sourceId: this.sourceId,
                        name: this.editFeature.name3,
                        meaning: this.editFeature.meaning3,
                        source: this.editFeature.source3 ? this.sources[this.editFeature.source3] : '',
                        sourceDetail: this.editFeature.sourceDetail3,
                    });
                    this.sourceId++;
                }
                if (this.editFeature.name4) {
                    this.addedSources.push({
                        sourceId: this.sourceId,
                        name: this.editFeature.name4,
                        meaning: this.editFeature.meaning4,
                        source: this.editFeature.source4 ? this.sources[this.editFeature.source4] : '',
                        sourceDetail: this.editFeature.sourceDetail4,
                    });
                    this.sourceId++;
                }
                if (this.editFeature.name5) {
                    this.addedSources.push({
                        sourceId: this.sourceId,
                        name: this.editFeature.name5,
                        meaning: this.editFeature.meaning5,
                        source: this.editFeature.source5 ? this.sources[this.editFeature.source5] : '',
                        sourceDetail: this.editFeature.sourceDetail5,
                    });
                    this.sourceId++;
                }
            } else {
                // new feature
                this.enteredBy = this.user.name;
                this.approved = 0;
            }
        } else {
            this.$store.dispatch('resetEditFeature');
            this.resetData();
        }
    }

    public resetData() {
        if (this.markerGraphic) {
            this.mapView.graphics.remove(this.markerGraphic);
        }
        this.cancelAddPoint();
        this.objectId = null;
        this.englishName = '';
        this.smithName = '';
        this.smithName2 = '';
        this.name = '';
        this.sourceId = 0;
        this.meaning = '';
        this.source = '';
        this.sourceDetail = '';
        this.translation = '';
        this.comment = '';
        this.addedSources = [];
        this.x = 0;
        this.y = 0;
        this.county = 'Undefined';
        this.enteredBy = '';
        this.approved = 0;
        this.audioFile = null;
        this.video = '';
        this.videos = [];
    }

    public mounted() {
        console.log('AddData: mounted()');
    }

    public showMarker() {
        console.log('AddData: showMarker()');
        this.markerGraphic = new Graphic({
            geometry: new Point({
                x: this.x,
                y: this.y,
                spatialReference: {
                    wkid: 3857,
                },
            }),
            symbol: this.newPointSymbol,
        });
        this.mapView.graphics.add(this.markerGraphic);
    }

    public countyFromCode(code: string) {
        switch (code) {
            case 'AP':
                return 'Annapolis County';
            case 'AT':
                return 'Antigonish County';
            case 'CB':
                return 'Cape Breton County';
            case 'CO':
                return 'Colchester County';
            case 'CU':
                return 'Cumberland County';
            case 'DI':
                return 'Digby County';
            case 'GU':
                return 'Guysborough County';
            case 'HN':
                return 'Hants County';
            case 'HX':
                return 'Halifax County';
            case 'IN':
                return 'Inverness County';
            case 'KI':
                return 'Kings County';
            case 'LU':
                return 'Lunenburg County';
            case 'PI':
                return 'Pictou County';
            case 'QU':
                return 'Queens County';
            case 'RI':
                return 'Richmond County';
            case 'SH':
                return 'Shelburne County';
            case 'VI':
                return 'Victoria County';
            case 'YA':
                return 'Yarmouth County';
            default:
                return 'Undefined';
        }
    }

    public addPoint() {
        console.log('AddData: addPoint()');
        this.showInstruction = true;

        if (this.markerGraphic) {
            this.mapView.graphics.remove(this.markerGraphic);
        }

        const communitiesLayer: __esri.FeatureLayer = new FeatureLayer({
            url: this.communitiesLayerUrl,
        });
        const query: __esri.Query = communitiesLayer.createQuery();

        this.eventHandler = this.mapView.on('click', (event: any) => {
            this.isCountyLoading = true;
            this.markerGraphic = new Graphic({
                geometry: event.mapPoint,
                symbol: this.newPointSymbol,
            });
            this.mapView.graphics.add(this.markerGraphic);
            query.geometry = event.mapPoint;
            query.datumTransformation = 1946; // "NAD_1983_CSRS_To_WGS_1984_2"
            communitiesLayer.queryFeatures(query).then( (results: __esri.FeatureSet) => {
                if (results.features.length) {
                    const countyCode = results.features[0].attributes.CO_CODE;
                    this.county = this.countyFromCode(countyCode);
                } else {
                    this.county = 'Undefined';
                }
                this.isCountyLoading = false;
            });
            this.x = event.mapPoint.x;
            this.y = event.mapPoint.y;
            this.eventHandler.remove();
            this.eventHandler = null;
            this.showInstruction = false;
        });
    }

    public cancelAddPoint() {
        if (this.eventHandler) {
            this.eventHandler.remove();
        }
        this.eventHandler = null;

        this.showInstruction = false;
    }

    public onAddSource() {
        console.log('AddData: onAddSource()');
        this.addedSources.push({
            sourceId: this.sourceId,
            name: this.name,
            meaning: this.meaning,
            source: this.source,
            sourceDetail: this.sourceDetail,
        });
        this.sourceId++;
        this.name = '';
        this.meaning = '';
        this.source = '';
        this.sourceDetail = '';
    }

    public onAddVideo() {
        console.log('AddData: onAddVideo()');
        if (this.videos) {
            this.videos.push('');
        }
    }

    public onDeleteSource(id: number) {
        console.log('AddData: onDeleteSource()');
        this.addedSources = this.addedSources.filter((obj: any) => obj.sourceId !== id);
    }

    public validateAudioFile() {
        console.log('AddData: validateAudioFile()');
        this.$store.dispatch('getAudioFileNames');
        if (this.audioFile) {
            console.log(this.audioFile);
            if (this.audioFile.size > this.maxFileSize) {
                this.$store.dispatch('notify', 'File did not pass validation constraints');
                this.audioFile = null;
            }
        }
    }

    public clearAudioFile(oldValue: File) {
        console.log('AddData: clearAudioFile()');
        console.log(oldValue);
        // if (oldValue && oldValue.name) {
        //     this.$store.dispatch('deleteAudioFile', oldValue.name);
        // }
    }

    public async onSubmit() {
        console.log('AddData: onSubmit()');
        this.isSaving = true;
        const placename: Placename = new Placename();
        // careful, the presense of objectId determines if it is new or update
        if (this.objectId) {
            placename.objectId = this.objectId;
        }
        placename.x = this.x;
        placename.y = this.y;
        placename.county = this.county;
        placename.smithName = this.smithName;
        placename.smithName2 = this.smithName2;
        placename.englishName = this.englishName;
        placename.translation = this.translation;
        placename.comment = this.comment;
        if (this.addedSources.length >= 1) {
            placename.name1 = this.addedSources[0].name;
            placename.meaning1 = this.addedSources[0].meaning;
            placename.source1 = Object.keys(this.sources).find((key) => this.sources[key] === this.addedSources[0].source);
            placename.sourceDetail1 = this.addedSources[0].sourceDetail;
        }
        if (this.addedSources.length >= 2) {
            placename.name2 = this.addedSources[1].name;
            placename.meaning2 = this.addedSources[1].meaning;
            placename.source2 = Object.keys(this.sources).find((key) => this.sources[key] === this.addedSources[1].source);
            placename.sourceDetail2 = this.addedSources[1].sourceDetail;
        }
        if (this.addedSources.length >= 3) {
            placename.name3 = this.addedSources[2].name;
            placename.meaning3 = this.addedSources[2].meaning;
            placename.source3 = Object.keys(this.sources).find((key) => this.sources[key] === this.addedSources[2].source);
            placename.sourceDetail3 = this.addedSources[2].sourceDetail;
        }
        if (this.addedSources.length >= 4) {
            placename.name4 = this.addedSources[3].name;
            placename.meaning4 = this.addedSources[3].meaning;
            placename.source4 = Object.keys(this.sources).find((key) => this.sources[key] === this.addedSources[3].source);
            placename.sourceDetail4 = this.addedSources[3].sourceDetail;
        }
        if (this.addedSources.length >= 5) {
            placename.name5 = this.addedSources[4].name;
            placename.meaning5 = this.addedSources[4].meaning;
            placename.source5 = Object.keys(this.sources).find((key) => this.sources[key] === this.addedSources[4].source);
            placename.sourceDetail5 = this.addedSources[4].sourceDetail;
        }

        placename.video = this.videos ? this.videos.join('|') : '';
        placename.video = placename.video.replace('||', '|');
        if (placename.video.endsWith('|')) {
            placename.video = placename.video.slice(0, -1);
        }
        if (placename.video.startsWith('|')) {
            placename.video = placename.video.slice(1, placename.video.length);
        }
        placename.video = placename.video.substring(0, 255);
        placename.approved = this.approved;
        placename.enteredBy = this.enteredBy;

        // this.$store.dispatch('uploadAudioFile', this.audioFile);

        if (this.audioFile && this.audioFile.name && this.audioFile.size > 0) {
            // upload file
            placename.audioLink = await this.uploadFile();
        } else if (this.audioFile && this.audioFile.name) {
            // set name
            placename.audioLink = this.audioFile.name;
        } else {
            placename.audioLink = '';
        }

        // (this.$refs.myForm as VForm).resetValidation();
        console.log(placename);

        this.$store.dispatch('addPlacename', placename);
    }

    public async uploadFile(): Promise<string> {
        if (this.audioFile) {
            const formData = new FormData();
            formData.set('file', this.audioFile);
            return await PlacenamesService.uploadAudio(formData)
            .then((response: any) => {
                console.log(response.data);
                // returns a sanitized filename
                return response.data;
            })
            .catch((error: any) => {
                console.error(error);
                this.$store.dispatch('notify', error);
                return '';
            });
        }
        return '';
    }

    public closeEditor() {
        console.log('AddData: closeEditor()');
        this.$q.dialog({
            title: 'Confirm',
            message: 'Are you sure? Edits will be lost',
            cancel: true,
            persistent: false,
        }).onOk(() => {
            this.$store.dispatch('drawerToggleLeft', null);
            this.resetData();
        }).onCancel(() => {
            // console.log('>>>> Cancel')
        });
    }
}

